import {Component, EventEmitter, Input, OnChanges, Output, ViewEncapsulation} from '@angular/core';
import {WaaImplementedValue, WaaValue} from "./models/widget-app-assessment-v0-args.dto";

@Component({
  selector: 'pt-waa-edit-row-col3',
  template: `
    <ng-select
      *ngIf=" scenarioD || scenarioI || scenarioR;"
      class="waa-ng-select"
      [disabled]="disabled"
      [ngStyle]="{'border-color': currentBorderColor}"
      [items]="implemented"
      [bindValue]="'value'"
      [bindLabel]="'label'"
      [ngModel]="currentValue.implementedValue"
      (ngModelChange)="ngSelectChangeRowValue($event)"
      [searchable]='false'
      [clearable]='false'>
    </ng-select>
  `,
  styles: [`
    .waa-ng-select {
      margin-left: 5px;
      height: 100%;
      width: 160px;
      border: 1px solid white;
      background: white;
    }

    .waa-ng-select .ng-select-container {
      height: 25px !important;
      min-height: 25px !important;
      border-radius: 0;
    }

    .waa-ng-select-empty .ng-select-container {
      background: #ffff83 !important;
    }

  `],
  encapsulation: ViewEncapsulation.None
})
export class WaaEditRowCol3Component implements OnChanges {
  @Input() uuid: string;
  @Input() disabled = false;
  @Input() scenarioR: boolean;
  @Input() scenarioI: boolean;
  @Input() scenarioD: boolean;
  @Input() implemented: WaaImplementedValue[];
  @Input() value: WaaValue[];
  @Output() changeRowImplementedValue = new EventEmitter<number>();

  public currentValue: WaaValue = this.getEmptyValue()
  public currentBorderColor: string | undefined;

  ngOnChanges(): void {
    if (this.value) {
      const currentValue = this.value.find((v) => v.uuid === this.uuid);
      this.currentValue = currentValue ? JSON.parse(JSON.stringify(currentValue)) : this.getEmptyValue();
      this.currentValue.implementedValue = Number.isSafeInteger(this.currentValue.implementedValue) ? this.currentValue.implementedValue : -1000;
      this.currentBorderColor = this.implemented.find(i => i.value === this.currentValue.implementedValue)?.color;
    } else {
      this.currentValue = this.getEmptyValue()
    }
  }

  ngSelectChangeRowValue(implementedValueSelected: number) {
    this.changeRowImplementedValue.emit(implementedValueSelected);
  }

  private getEmptyValue(): WaaValue {
    const response: WaaValue = {
      uuid: this.uuid,
      note: '',
      implementedValue: -1000
    };
    return response;
  }
}
